import React from 'react';
import PropTypes from 'prop-types';
import './style.scss';

export function Content(props) {
  return (
    <div className='notebookContent'>
      <div className='notebookContent__body'>
        {props.titleComponent}
        {props.contentsComponent}
      </div>
      {props.footerComponent}
    </div>
  );
}

Content.propTypes = {
  /**
   * Title component to display the title of Content Section
   */
  titleComponent: PropTypes.oneOfType([PropTypes.element, PropTypes.array])
    .isRequired,
  /**
   * Contents to be displayed in the section
   */
  contentsComponent: PropTypes.oneOfType([PropTypes.element, PropTypes.array])
    .isRequired,
  /**
   * Footer component to be displayed in section
   */
  footerComponent: PropTypes.oneOfType([PropTypes.element, PropTypes.array])
    .isRequired,
};

export {ContentItems} from './ContentItems';
export {Footer} from './Footer';
export {Title} from './Title';
